import i18next from 'i18next';

i18next.addResources('en', 'CSVsGeneratedModal', {
  title: 'CSVs generated',
  description: 'A link to the file with the CSVs has been sent via email.',
  confirm: 'Confirm'
});
